import {ADMIN_ROLE,SUBMITTER_ROLE} from '../../../constants/global';
import { ADMIN, CDS, PROFILE } from '../../../constants/status';
import { SUBMITTED_FOR_REVIEW, PUBLISHED, EDITOR_ROLE } from './exportfiles';
import * as React from 'react';

const RenderButton = ({cat_id, roleNumber, status, isLocked, onSubmit, unSubmit, onPublish, enable}) => {
  //This is the submit/unsubmit button logic in module page. 
  if(cat_id===CDS) 
  return (<button style={{backgroundColor:'#fedb00', color:'black'}} data-testid='submitBtn'
        type='button' className='cb-btn cb-btn-primary'  onClick={onSubmit} disabled={!enable||isLocked}>Submit</button>);
  
  if(cat_id===PROFILE || cat_id===ADMIN)
  return (<button style={{backgroundColor:'#fedb00', color:'black'}} data-testid='submitBtn'
        type='button' className='cb-btn cb-btn-primary'  onClick={onSubmit}>Submit</button>);
  
  switch (roleNumber) {
    case ADMIN_ROLE:
      return (<>
      {(status?.toUpperCase()===SUBMITTED_FOR_REVIEW || status?.toUpperCase() === PUBLISHED) ? 
        <button style={{backgroundColor:'#fedb00', color:'black'}} type='button' data-testid='submitBtn' className='cb-btn cb-btn-primary'  onClick={unSubmit}>Unsubmit</button>:
        <button style={{backgroundColor:'#fedb00', color:'black'}} data-testid='submitBtn' type='button' className='cb-btn cb-btn-primary'  onClick={onSubmit}>Submit</button>
      }
      {status?.toUpperCase()!==SUBMITTED_FOR_REVIEW ?
      <button style={{backgroundColor:'white', color:'black', marginLeft:'5px'}} disabled data-testid='publishBtn' type='button' className='cb-btn cb-btn-primary'  onClick={onPublish}>Accept</button>
      :
      <button style={{backgroundColor:'white', color:'black', marginLeft:'5px'}} data-testid='publishBtn' type='button' className='cb-btn cb-btn-primary'  onClick={onPublish}>Accept</button>}
      </>);

    case SUBMITTER_ROLE:
      return (<>
        <button style={{backgroundColor:'#fedb00', color:'black'}} data-testid='submitBtn' type='button' disabled={status?.toUpperCase()=== PUBLISHED || isLocked===true || status?.toUpperCase()=== SUBMITTED_FOR_REVIEW} className='cb-btn cb-btn-primary' onClick={onSubmit}>Submit for review</button>
      </>);

    case EDITOR_ROLE:
      return (<></>);
      
    default:
      return (<></>);
  }
};

export default RenderButton;